import ReactDOM from "react-dom/client";
import "./fonts.css";
import "./index.css";
import App from "./App";
import "./i18n";
import { BrowserRouter as Router } from "react-router-dom";
import { AuthProvider } from "./Context/AuthContext";
import { PostHogProvider } from "posthog-js/react";
import "leaflet/dist/leaflet.css";

// ReactDOM.render(
//   <Router>
//     <AuthProvider>
//       <App />
//     </AuthProvider>
//   </Router>,
//   document.getElementById("root")
// );

const options = {
  api_host: import.meta.env.VITE_APP_PUBLIC_POSTHOG_HOST,
  //Disable surverys & recorders to boost performance, as we don't use them
  disable_session_recording: true,
  disable_surveys: true,
};

ReactDOM.createRoot(document.getElementById("root")).render(
  <Router>
    <PostHogProvider
      options={options}
      apiKey={import.meta.env.VITE_APP_PUBLIC_POSTHOG_KEY}
    >
      <AuthProvider>
        <App />
      </AuthProvider>
    </PostHogProvider>
  </Router>,
);
